<template>
     <div class="deposit-request">
            <div class="deposit-request-sec">
               <div class="thm-heading">
                  <img loading="lazy" src="@/assets/images/loss-icon.webp" alt="loss-icon">
                  <h3>{{ walletDetails.name }} request Rejected</h3>
               </div>
            </div>
         </div>
</template>
<script>
export default {
    name: "DepositRequestRejected",
    props:['walletDetails'],
}
</script>